import { createContext, useContext } from "react";

export type ToastKind = "success" | "error" | "info";

export interface ToastApi {
  /** Shows a short message that dismisses itself after a few seconds, or sooner if the person closes it. */
  show: (message: string, kind?: ToastKind) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** Returns the toast API. Must be called beneath a `ToastProvider`. */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (api === null) {
    throw new Error("useToast must be used inside a ToastProvider.");
  }

  return api;
}
